/*
 *  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  *  author : BS
 *  *  date : 1/18/23, 5:29 PM
 */

import {Tab} from './tab';
import {Entity} from '../entity/entity';

export class DataTab<T extends Entity> extends Tab {
  public data: T;
  public copy: T;

  constructor(id: string, label: string, contentId: string, data: T) {
    super(id, label, contentId);
    this.data = data;
  }
}
